import { useState, useEffect, useMemo } from 'react'
import { STORAGE_CONSTANTS, } from "../../constants";
import { getUserStatus, initData } from '../../../business/appLanding/functions';
import { isEmpty, storageService, } from "../../../utils/validators";
import Toast from '../../../common/ui/Toast';
import store from '../../../dataLayer/store';
import { setKyc, setUser as setUserData } from 'businesslogic/dataStore/reducers/app';

function useUserKycHook() {
    const [kyc, setUserKyc] = useState(
        storageService().getObject(STORAGE_CONSTANTS.KYC) || {}
    );
    const [user, setUser] = useState(
        storageService().getObject(STORAGE_CONSTANTS.USER) || {}
    );

    const isKycPopulated = useMemo(() => !isEmpty(kyc), [kyc]);
    const isUserPopulated = useMemo(() => !isEmpty(user), [user]);
    const isUserKycPopulated = useMemo(() => isKycPopulated && isUserPopulated);

    const [isLoading, setIsLoading] = useState(function () {
        if (!isUserPopulated || !isKycPopulated) {
            return true;
        }
        return false;
    });

    const { isMfInvested, userKycReady, mfApplicationStatus } = useMemo(
        () => getUserStatus(kyc, user),
        [kyc, user]
    );

    useEffect(() => {
        const init = async () => {
            try {
                await initData();
                const kycDetails = storageService().getObject(STORAGE_CONSTANTS.KYC);
                const userDetails = storageService().getObject(STORAGE_CONSTANTS.USER);
                setIsLoading(false);
                setUser(userDetails);
                setUserKyc(kycDetails);
            } catch(err) {
                Toast(err.message);
            }
        };
        if (!isUserPopulated || !isKycPopulated) {
            init();
        }
    }, []);

    const updateKyc = (kycData) => {
        if (kycData) {
            storageService().setObject("kyc", kycData);
            setUserKyc(kycData);
            store.dispatch(setKyc(kycData));
        }
    };

    const updateUser = (userData) => {
        if (userData) {
            storageService().setObject("user", userData);
            setUser(userData);
            store.dispatch(setUserData(userData));
        }
    };

    return {
        kyc,
        user,
        isLoading,
        isMfInvested,
        userKycReady,
        mfApplicationStatus,
        updateKyc,
        updateUser,
        isUserPopulated,
        isKycPopulated,
        isUserKycPopulated
    };
}

export default useUserKycHook
